import React, { SVGProps } from "react";

export default function SupUpArrowAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.49992 7.16205L5.38404 12.1011L4.61581 11.4609L9.99993 5L15.384 11.4609L14.6158 12.1011L10.4999 7.16205V15H9.49992V7.16205Z" fill="currentColor" />
    </svg>
  );
}
